export default "__VITE_ASSET__aLXlf_aU__"